/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login} from '../redux/AuthCRUD'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import { SSOUserModel } from '../models/UserModel'
import { AxiosError, AxiosResponse } from 'axios'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required('Username is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        login(values.username, values.password)
          .then(({data: {access_token}}) => {
            setLoading(false)
            dispatch(auth.actions.login(access_token))
          })
          .catch((err: AxiosError) => {
            setLoading(false)
            setSubmitting(false)
            setStatus(err.message)
          })
      }, 1000)
    },
  })
  

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {formik.status ? (
        <div className='alert alert-danger d-flex align-items-center p-5 mb-10'>
          <i className='fs-5 text-danger fas fa-exclamation-triangle me-4'></i>
          <div className='d-flex flex-column'>
            <h6 className='text-danger mb-0'>{formik.status}</h6>
          </div>
        </div>
      ) : null}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>SSO Username</label>
        <input
          placeholder='e.g., abcd001'
          {...formik.getFieldProps('username')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.username && formik.errors.username},
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off'
          autoFocus
        />

        <div className='fv-plugins-message-container text-danger'>
          {!formik.errors.username && <span style={{color: 'rgba(255,255,255,0)'}}>Placeholder</span>}
          {formik.errors.username && <span role='alert'>{formik.errors.username}</span>}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-4'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>SSO Password</label>
            {/* end::Label */}
          </div>
        </div>
        <div className='input-group'>
          <input
            type={showPassword ? 'text' : 'password'}
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          <a className='input-group-text border-0' href='#' onClick={toggleShowPassword}>
            <span
              className={clsx(
                'fs-5',
                {'bi-eye-fill': showPassword},
                {'bi-eye-slash': !showPassword}
              )}
            ></span>
          </a>
        </div>

        <div className='fv-plugins-message-container text-danger'>
          <div className='fv-help-block'>
            {!formik.errors.password && (
              <span style={{color: 'rgba(255,255,255,0)'}}>Placeholder</span>
            )}
            {formik.errors.password && <span role='alert'>{formik.errors.password}</span>}
          </div>
        </div>
      </div>
      {/* end::Form group */}

      {/* <div className='mb-4 text-end'> */}
        {/* begin::Link */}
        {/* <Link to='/auth/forgot-password' className='link-danger fs-6 fw-bolder'>
          Forgot Password ?
        </Link> */}
        {/* end::Link */}
      {/* </div> */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-danger w-100 my-4'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Login</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Mohon tunggu 
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
